// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.createLiveNav {
    position: fixed;
    width: 100%;
    top: 0%;
}

.createLiveSignOut {
    /* top: 22%;
    right: 3%; */
    position: static;
}

.menubtn {
    display: none;
    margin-right: 2%;
}

.menuoptions {
    display: none;
}

.menuoptions2 {
    display: flex;
    align-items: center;
    gap: 20px;

}

@media screen and (max-width: 890px) {

    .responsiveContainer {
        width: 100% !important;  /* Set to 100% for mobile and tablet */
        flex-direction: column !important; /* Stack items vertically on smaller screens */
    }

    .topDiv {
        width: 100%; /* Full width for mobile */
    }

    .responsiveRightDiv {
        width: 100% !important; /* Set to 100% for mobile and tablet */
        position: relative !important;
    }

    .createLeftDiv {
        width: 100%; /* Full width for mobile */
    }

    .createRightDiv {
        width: 100%; /* Full width for mobile */
        padding: 0; /* Remove padding */
    }

    .pdfDisplayDiv {
        width: 80%; /* Adjust PDF viewer width */
        margin: auto; /* Center the PDF viewer */
    }

    .createFormSection {
        margin-bottom: 2%; /* Reduce margin for better spacing */
    }

    .createLiveSaveProfileBtn {
        width: 100%; /* Full width for buttons */
    }

    .templateDiv {
        width: 100%; /* Full width for template selection */
    }

    .templateImg {
        width: 80%; /* Adjust image size for mobile */
    }

    .menubtn {
        display: block;
        border: none;
        outline: none;
    }

    .menuoptions2 {
        display: none;
    }

    .menuoptions {
        display: flex;
        align-items: center;
        gap: 20px;
        position: fixed;
        top: 65px;
        right: 5px;
        flex-direction: column;
        background-color: #ecf8e5;
        padding: 20px;
        border-radius: 20px;
        z-index: 10;
    }

    .liveProfileDivLeft {
        width: 66%; /* Full width for both columns */
        /* padding-top: 5%; */
        /* padding-left: 5%; */
    }

    .liveProfileDivRight {
        width: 33%; /* Full width for both columns */
        /* padding-top: 5%;  */
        /* right: -6.8%; */
    }
}

.responsiveContainer {
    display: flex;
    flex-direction: row;
    width: 50%; /* Set to 50% for laptop view */
    left: 0%;
    margin-top: 5%;
}

.topDiv {
    flex: 1 1; /* Take available space */
    padding-top: 5%; /* Add padding if needed */
}

.responsiveRightDiv {
    position: fixed;
    right: 0%;
    top: 3%;
    padding-top: 5%;
    width: 50%; /* Default width for laptops and larger screens */
}

.createLeftDiv {
    width: 50%;
    display: inline-block;
}

.rightDivCreateLive {
    /* background-color: #346571; */
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.createLeftFormDiv {
    padding: 4%;
    padding-top: 7%;
    padding-left: 8%;
    width: 100%;
}

.createRightDiv {
    /* background-color: aquamarine; */
    padding: 0%;
    padding-top: 0%;
    z-index: -1;
    right: 0%;
    flex: 1 1;
}

.fixed-preview-button {
    position: fixed; /* Fixes the button to the viewport */
    bottom: 20px; /* Distance from the bottom of the viewport */
    left: 50%; /* Center the button horizontally */
    transform: translateX(-50%); /* Adjust for the button's width */
    z-index: 1000; /* Ensure it appears above other content */
    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
    border-radius: 25px;
    color: rgb(255, 255, 255);
    cursor: pointer;
    display: inline-block;
    width: 45%;
    font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
    padding: 7px 20px;
    text-align: center;
    text-decoration: none;
    transition: all 250ms;
    border: 0;
    font-size: 14px;
    font-weight: 600;
    user-select: none;
    -webkit-user-select: none;
  }

  .fixed-preview-button:hover {
    background-color: #4F80FF;
    color: white;
  }

.downloadPdfBtn {
    /* position: absolute; */
    /* z-index: 20; */
    /* background-color:rgb(23 33 58); */
    /* right: 29.3%; */
    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
    border: none;
    border-radius: 25px;
    font-weight: 550;
    color: #ffffff;
    height: 30px;
    width: 38%;
    /* top: 33%; */
}

.downloadPdfBtn:hover {
    /* position: absolute;
    z-index: 20; */
    /* background-color:rgb(23 33 58); */
    /* right: 39%; */
    border: none;
    /* color: rgb(34 197 94); */
    /* top: 34%; */
    font-weight: 550;
}

.downloadPDFIcon {
    padding-bottom: 3%;
}

.createFormSection {
    margin-bottom: 4%;
}

.createUplouploadPictureDivLabel {
    top: 1%;
    left: 33%;
}

/* .uploadPictureInput {
   
} */

.createUploadedPicture {
    left: 5%;
    bottom: 8%;
}


.createUploadPictureInput {
    bottom: -5%;
    background-color: none !important;
    width: 50% !important;
    padding-left: 5px;
    padding-right: 2px;
    position: absolute;
    /* top: 42%; */
    bottom: -16%;
    /* right: 8%; */
    left: 33% !important;
    font-size: 14px;

}

.createUplouploadPhotoDivIcon {
    left: 4%;
}

.createUplouploadPhotoDivGif {
    /* background-color: red; */
    position: relative;
    align-items: center;
    text-align: center;
    width: 70px;
    height: 70px;
    left: 1%;

}

.deleteUploadedPhotoIcon {
    position: absolute;
    bottom: -5%;
    right: 5%;
    color: grey;
    color: goldenrod;

}

.deleteUploadedPhotoIcon:hover {
    position: absolute;
    bottom: -5%;
    right: 5%;
    color: rgb(112, 24, 24);
}

.createLiveSaveProfileBtn {
    width: 100%;
    background-color: #5ec57e;
    color: white;
}

.createLiveSaveProfileBtn:hover {
    width: 100%;
    /* background-color: #c2fbd7; */
    box-shadow: rgba(0, 0, 0, 0.3) 0 4px 8px;
    border-radius: 25px;
    color: #ffffff;
}

.createSaveProfileDiv {
    position: relative;
    align-items: center;
    text-align: center;
    margin-bottom: 8%;
}

.pdfDisplayDiv {
    background-color: white;
    width: 70%;
    min-height: 84vh;
    margin: auto;
    margin-top: 2%;
    margin-bottom: 5%;
    padding: 2%;
    overflow: auto;
    max-height: 84vh;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 5px;
}

.mainCreateLiveDiv1 {
    display: flex;
    flex-direction: row;
}

.rightHeadDiv {
    position: relative;
    top: 0;
    background-color: bisque;
    width: 100%;
    height: 65px;
}

.topDivTemplate1 {
    margin-left: 3.2%;
    margin-bottom: 2%;
}

.imageDiv {
    display: inline-block;
    /* background-color: aqua; */
    margin: 0;
    padding: 0;
    width: 15%;
    position: relative;
    height: 40px;
}

.displayImage {
    width: 45px;
    position: absolute;
    top: 5%;
}

.nameDiv {
    margin: 0;
    padding: 0;
    display: inline-block;
    width: 70%;
    /* background-color: #5ec57e; */
    margin-top: 1%;
}

.resumeName {
    margin: 0;
    padding: 0;
    margin-left: 3%;
    font-size: 14px;
    padding-top: 3%;
}

.resumeTtile {
    font-size: 8px;
    margin: 0;
    padding: 0;
    margin-left: 3%;
}

.liveProfileDiv {
    /* background-color: bisque; */
    font-size: 10px;
    width: 95%;
    margin: auto;
    margin-top: 4%;
    padding: 0;
}

.liveProfileDivLeft {
    padding: 0;
}

.liveProfileDivRight {
    padding: 0;
    text-align: justify;
    text-align: left !important;
    overflow-wrap: break-word;
}

.profileIcon {
    position: absolute;
    bottom: 23%;
    left: 0;
}

.profileName {
    padding: 0;
    margin: 0;
    padding-left: 4%;
    position: relative;
    font-weight: 520;
    color: rgb(30, 37, 50);
    color: rgb(22, 89, 143);

    /* font-family: 'Poppins', sans-serif;
font-family: 'Open Sans', sans-serif; */
}

.profileText {
    font-size: 7px;
    text-align: justify;
    padding-left: 5.6%;
    color: rgb(62, 63, 78);
    ;
    /* font-family: 'Open Sans', sans-serif;
font-family: 'Poppins', sans-serif;
font-family: 'Roboto', sans-serif;  */
    /* font-family: 'Open Sans', sans-serif;
font-family: 'Poppins', sans-serif;
font-family: 'Roboto', sans-serif; */
}

.employmentHistName {
    margin-top: -3%;
}

.profileEmploymentName {
    font-size: 7px;
    font-weight: 500;
    padding: 0;
    margin: 0;
    padding-left: 5.6%;
    margin-top: 1.8%;
    color: rgb(30, 37, 50);
}

.employmentTime {
    font-size: 6px;
    padding-left: 5.6%;
    padding-bottom: 0;
    margin-bottom: 0;
}

.employmetnProfileText {
    padding-left: 5.6%;
    margin-top: 2%;
}

.liveProfileDivRight {
    padding-left: 20px;
    padding-top: 0.5%;
}

.profileDetails {
    font-size: 8px;
    font-weight: 500;
    margin-bottom: 1.6%;

}

.profileDetailsText {
    font-size: 7px;
    text-align: justify;
    padding: 0;
    margin: 0;
    padding-top: 1%;
}

.profileDetailSubHeading {
    margin-top: 7%;
}

.otherProfileDetails {
    margin-top: 6%;
    margin-bottom: 0;
}

.liveSkills {
    font-weight: 400;
    font-size: 8px;
}

.emailProfileDetailsText {
    color: rgb(26, 145, 240);
    font-weight: 500;
}

.DOBProfileDetailsText {
    color: rgb(130, 139, 162);
    font-weight: 600;
    font-size: 7px;
}

.downloadPdfMainDiv {
    /* background-color: #346571; */
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    /* background-image: url('https://media1.giphy.com/media/xTiTniuHdUjpOlNo1q/200w.webp?cid=ecf05e47oyp7v59c7cncnujecgmxgtdygfh3dyenydkegtuz&ep=v1_gifs_search&rid=200w.webp&ct=g'); */
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 100%;
    align-items: center;
    text-align: center;
    position: absolute;
    top: 0%;
    height: 100vh;
}

.realBdfGoBackBtn {
    width: 120px;
    border: none;
    /* color: #346571; */
    /* color: green; */
    /* color: #5ec57e; */
    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
    font-weight: 550;
    width: 120px;
    border-radius: 5px;
    position: absolute;
    right: 3%;
    top: 2.5%;
    background-color: #c2fbd7;
    border-radius: 25px;
    /* box-shadow: rgba(44, 187, 99, .2) 0 -25px 18px -14px inset, rgba(44, 187, 99, .15) 0 1px 2px, rgba(44, 187, 99, .15) 0 2px 4px, rgba(44, 187, 99, .15) 0 4px 8px, rgba(44, 187, 99, .15) 0 8px 16px, rgba(44, 187, 99, .15) 0 16px 32px;
    box-shadow: rgba(44, 187, 99, .35) 0 -25px 18px -14px inset, rgba(44, 187, 99, .25) 0 1px 2px, rgba(44, 187, 99, .25) 0 2px 4px, rgba(44, 187, 99, .25) 0 4px 8px, rgba(44, 187, 99, .25) 0 8px 16px, rgba(44, 187, 99, .25) 0 16px 32px; */
    color: rgb(255, 255, 255);
    cursor: pointer;
    display: inline-block;
    font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
    padding: 7px 20px;
    text-align: center;
    text-decoration: none;
    transition: all 250ms;
    border: 0;
    font-size: 14px;
    font-weight: 600;
    user-select: none;
    -webkit-user-select: none;
    z-index: 15;
}

.realBdfGoBackBtn:hover {
    background-color: #5ec57e;
    color: #ecf8e5;
    box-shadow: rgba(0, 0, 0, 0.2) 0 4px 8px; /* Example shadow with black color */}

.languageLevel {
    font-size: 7px !important;
}

.dashboardBtn {
    /* position: absolute;
    z-index: 20; */
    /* background-color: rgb(23 33 58); */
    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
    /* right: 39%; */
    border: none;
    border-radius: 25px;
    color: rgb(255, 255, 255);
    /* top: 34%; */
    font-weight: 550;
    height: 30px;
    width: 28%;
}

.dashboardBtn:hover {
    /* position: absolute;
    z-index: 20; */
    /* background-color:rgb(23 33 58); */
    /* right: 39%; */
    border: none;
    /* color: rgb(34 197 94); */
    /* top: 34%; */
    font-weight: 550;
}

.templateDiv {
    /* background-color: #c2fbd7; */
    padding-top: 2%;
    padding-bottom: 2%;
    width: 95%;
    margin: auto;
    margin-top: -4%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.templateImgDiv {
    width: 50%;
    display: inline-block;
}

.templateImg {
    width: 100px;
    cursor: pointer;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
    box-shadow: rgba(12, 192, 72, 0.1) 0px 4px 12px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.templateDiv {
    padding-top: 2%;
    padding-bottom: 2%;
}

.tempalteImage {
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.tempalteImage {
    width: 90%;
}

.templateDiv {
    margin-bottom: 5%;
    margin-top: 2%;
}

.carousel-item {
    height: 260px;
    background-color: white;
}

.live-carousel-control-next {
    right: -47px;
}

.live-carousel-control-next {
    background-color: #5ec57e;
    right: -20px;
    height: 34px;
    top: 72px;
    width: 26px;
}

.live-carousel-control-prev {
    left: -35px;
    height: 34px;
    top: 72px;
    width: 26px;
    background-color: #5ec57e;
}

.landing-carousel-control-next {
    background-color: #5ec57e;
    height: 40px;
    width: 30px;
    margin-right: 5%;
    margin-top: 22%;
}

.landing-carousel-control-prev {
    background-color: #5ec57e;
    height: 40px;
    width: 30px;
    margin-left: 5%;
    margin-top: 22%;
}

.tailorDivImg {
    width: 100%;
}

.createLiveHrLine {
    margin-bottom: 5%;
}

.liveInfoOuterDiv {
    background-color: red;
    background-color: transparent;
    position: relative;
    margin-top: 3%;

}

.aiItAnimationDiv {
    position: absolute;
    right: 3%;
    top: -5% !important;
    /* background-color: #346571; */
    background-color: transparent;
    /* background-color: blue; */
    height: 60px;
    cursor: pointer;
    z-index: 1;
}

.aiItAnimationDivDesc {
    position: absolute;
    right: 3%;
    top: -59% !important;
    /* background-color: #346571; */
    background-color: transparent;
    height: 28px;
    cursor: pointer;
}

.bulbGif {
    height: 50px;
    width: 50px;
    z-index: 5;
    pointer-events: none;
}

.cityLabelForm {
    margin-bottom: 4% !important;
}

.moveBtnCreateUp {
    background-color: transparent;
    /* background-color: #346571; */
    border: none;
    text-align: right;
    position: absolute;
    top: -2%;
    width: 10%;
    right: -2%;

}

.moveBtnCreateDown {
    background-color: transparent;
    /* background-color: #346571; */
    border: none;
    text-align: right;
    position: absolute;
    top: 1.7%;
    width: 10%;
    right: -2%;
}

.moveBtnCreateWebsiteUp {
    background-color: transparent;
    /* background-color: #346571; */
    border: none;
    text-align: right;
    position: absolute;
    top: -43%;
    width: 10%;
    right: 0%;
}

.moveBtnCreateWebsiteDown {
    background-color: transparent;
    /* background-color: #346571; */
    border: none;
    text-align: right;
    position: absolute;
    top: -16.5%;
    width: 10%;
    right: 0%;
}

.moveBtnCreateNotLiveDown {
    background-color: transparent;
    /* background-color: #346571; */
    border: none;
    text-align: right;
    position: absolute;
    top: 8.5%;
    width: 10%;
    right: -2%;
}

.infoTextDiv {
    position: absolute;
    /* visibility: hidden; */
    width: 200px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 10px;
    z-index: 1;
    top: -50px;
    /* Adjust this value to position the tooltip */
    left: 50%;
    margin-left: -100px;
    opacity: 0;
    transition: opacity 0.3s;
}

.SaveBtn {
    /* position: absolute;
    z-index: 20; */
    /* background-color:rgb(23 33 58); */
    /* right: 46.3%; */
    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
    border: none;
    border-radius: 25px;
    color: rgb(255, 255, 255);
    /* top: 34%; */
    font-weight: 550;
    height: 30px;
    width: 20%;
}

.SaveBtn:hover {
    /* position: absolute;
    z-index: 20; */
    /* background-color:rgb(23 33 58); */
    /* right: 39%; */
    border: none;
    /* color: rgb(34 197 94); */
    /* top: 34%; */
    font-weight: 550;
}

/* .checkTokenClass{
    box-shadow:  4px 4px 6px 0 rgba(255,255,255,.5),
              -4px -4px 6px 0 rgba(116, 125, 136, .5), 
    inset -4px -4px 6px 0 rgba(255,255,255,.2),
    inset 4px 4px 6px 0 rgba(0, 0, 0, .4);
  } */

/* 2 */
/* .btn-2 {
    background: rgb(96,9,240);
    background: linear-gradient(0deg, rgba(96,9,240,1) 0%, rgba(129,5,240,1) 100%);
    border: none;
    
  } */
.btn-2:before {
    height: 0%;
    width: 2px;
}

.btn-2 {
    border: none;
    box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, .5),
        -4px -4px 6px 0 rgba(116, 125, 136, .5),
        inset -2px -2px 6px 0 rgba(255, 255, 255, .2),
        inset 2px 2px 6px 0 rgba(0, 0, 0, .2);
}


.custom-btn {
    width: 180px;
    height: 40px;
    color: #fff;
    border-radius: 20px;
    padding: 10px 10px;
    font-family: 'Lato', sans-serif;
    font-weight: 500;
    background: transparent;
    cursor: pointer;
    transition: all 0.3s ease;
    /* position: absolute; */
    display: inline-block;
    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),
        5px 5px 15px 0px rgba(0, 0, 0, .1),
        4px 4px 5px 0px rgba(0, 0, 0, .1);
    outline: none;
}

.btn-2 {
    border: none;
    box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, .5),
        -4px -4px 6px 0 rgba(116, 125, 136, .5),
        inset -2px -2px 6px 0 rgba(255, 255, 255, .2),
        inset 2px 2px 6px 0 rgba(0, 0, 0, .2);
}

@media (max-width: 767px) {

    .uplouploadPictureBigDiv {
        width: 100%; /* Full width on mobile */
        padding: 10px; /* Add some padding */
        margin-bottom: 30px !important;
        margin-top: 30px !important;
    }

    .uplouploadPhotoDivIcon {
        right: 10%; /* Adjust icon position */
        bottom: 5%; /* Adjust icon position */
        height: 50px !important;
        width: 50px !important;
    }

    .uploadedPicture {
        right: 5%; /* Adjust image position */
        bottom: 5%; /* Adjust image position */
        width: 50px; /* Smaller image size */
        height: 50px; /* Maintain aspect ratio */
    }

    .uplouploadPictureDivLabel {
        top: 30px; /* Adjust label position */
        left: 0%; /* Adjust label position */
        position: relative !important;
    }

    .createUploadPictureInput{
        top: 0 !important;
        right: 0 !important;
    }
}

@media only screen and (max-width: 768px) {
    .SaveBtn {
        height: 30px;
        width: 100%;
    }
    .dashboardBtn {
        height: 30px;
        width: 100%;
    }
    .downloadPdfBtn {
        height: 30px;
        width: 100%;
    }

}`, "",{"version":3,"sources":["webpack://./src/styleSheet/createLive.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,OAAO;AACX;;AAEA;IACI;gBACY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;;AAEb;;AAEA;;IAEI;QACI,sBAAsB,GAAG,sCAAsC;QAC/D,iCAAiC,EAAE,8CAA8C;IACrF;;IAEA;QACI,WAAW,EAAE,0BAA0B;IAC3C;;IAEA;QACI,sBAAsB,EAAE,sCAAsC;QAC9D,6BAA6B;IACjC;;IAEA;QACI,WAAW,EAAE,0BAA0B;IAC3C;;IAEA;QACI,WAAW,EAAE,0BAA0B;QACvC,UAAU,EAAE,mBAAmB;IACnC;;IAEA;QACI,UAAU,EAAE,4BAA4B;QACxC,YAAY,EAAE,0BAA0B;IAC5C;;IAEA;QACI,iBAAiB,EAAE,qCAAqC;IAC5D;;IAEA;QACI,WAAW,EAAE,2BAA2B;IAC5C;;IAEA;QACI,WAAW,EAAE,sCAAsC;IACvD;;IAEA;QACI,UAAU,EAAE,iCAAiC;IACjD;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,eAAe;QACf,SAAS;QACT,UAAU;QACV,sBAAsB;QACtB,yBAAyB;QACzB,aAAa;QACb,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,UAAU,EAAE,gCAAgC;QAC5C,qBAAqB;QACrB,sBAAsB;IAC1B;;IAEA;QACI,UAAU,EAAE,gCAAgC;QAC5C,sBAAsB;QACtB,kBAAkB;IACtB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU,EAAE,+BAA+B;IAC3C,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,SAAO,EAAE,yBAAyB;IAClC,eAAe,EAAE,0BAA0B;AAC/C;;AAEA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,eAAe;IACf,UAAU,EAAE,iDAAiD;AACjE;;AAEA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,+BAA+B;IAC/B,yDAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,WAAW;IACX,eAAe;IACf,WAAW;IACX,SAAS;IACT,SAAO;AACX;;AAEA;IACI,eAAe,EAAE,qCAAqC;IACtD,YAAY,EAAE,6CAA6C;IAC3D,SAAS,EAAE,mCAAmC;IAC9C,2BAA2B,EAAE,kCAAkC;IAC/D,aAAa,EAAE,0CAA0C;IACzD,kEAAkE;IAClE,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,qBAAqB;IACrB,UAAU;IACV,8EAA8E;IAC9E,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;AAEF;IACI,wBAAwB;IACxB,iBAAiB;IACjB,oCAAoC;IACpC,kBAAkB;IAClB,kEAAkE;IAClE,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,UAAU;IACV,cAAc;AAClB;;AAEA;IACI;kBACc;IACd,oCAAoC;IACpC,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;IAC3B,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,SAAS;AACb;;AAEA;;GAEG;;AAEH;IACI,QAAQ;IACR,UAAU;AACd;;;AAGA;IACI,WAAW;IACX,iCAAiC;IACjC,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,eAAe;;AAEnB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,QAAQ;;AAEZ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,gBAAgB;;AAEpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,wCAAwC;IACxC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,2CAA2C;IAC3C,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,wBAAwB;IACxB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;IAC5B,SAAS;IACT,UAAU;IACV,UAAU;IACV,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,SAAS;IACT,UAAU;IACV,qBAAqB;IACrB,UAAU;IACV,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,eAAe;IACf,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,YAAY;IACZ,cAAc;IACd,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;AACX;;AAEA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;;IAEvB;uCACmC;AACvC;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;;IAEtB;;qCAEiC;IACjC;;oCAEgC;AACpC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;;AAEvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,yDAAyC;IACzC,oLAAoL;IACpL,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,kEAAkE;IAClE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,yBAAyB;IACzB,mBAAmB;IACnB;+OAC2O;IAC3O,yBAAyB;IACzB,eAAe;IACf,qBAAqB;IACrB,8EAA8E;IAC9E,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,wCAAwC,EAAE,oCAAoC,CAAC;;AAEnF;IACI,yBAAyB;AAC7B;;AAEA;IACI;kBACc;IACd,qCAAqC;IACrC,kEAAkE;IAClE,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI;kBACc;IACd,oCAAoC;IACpC,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;IAC3B,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,8IAA8I;IAC9I,+CAA+C;IAC/C,yFAAyF;AAC7F;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,kBAAkB;IAClB,cAAc;;AAElB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,+BAA+B;IAC/B,6BAA6B;IAC7B,4BAA4B;IAC5B,YAAY;IACZ,eAAe;IACf,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,oBAAoB;IACpB,+BAA+B;IAC/B,6BAA6B;IAC7B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;;AAEd;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,UAAU;IACV,8CAA8C;IAC9C,SAAS;IACT,mBAAmB;IACnB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI;kBACc;IACd,oCAAoC;IACpC,kBAAkB;IAClB,kEAAkE;IAClE,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI;kBACc;IACd,oCAAoC;IACpC,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;IAC3B,cAAc;IACd,gBAAgB;AACpB;;AAEA;;;;;KAKK;;AAEL,MAAM;AACN;;;;;KAKK;AACL;IACI,UAAU;IACV,UAAU;AACd;;AAEA;IACI,YAAY;IACZ;;;6CAGyC;AAC7C;;;AAGA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,wBAAwB;IACxB,qBAAqB;IACrB;;yCAEqC;IACrC,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ;;;6CAGyC;AAC7C;;AAEA;;IAEI;QACI,WAAW,EAAE,yBAAyB;QACtC,aAAa,EAAE,qBAAqB;QACpC,8BAA8B;QAC9B,2BAA2B;IAC/B;;IAEA;QACI,UAAU,EAAE,yBAAyB;QACrC,UAAU,EAAE,yBAAyB;QACrC,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,SAAS,EAAE,0BAA0B;QACrC,UAAU,EAAE,0BAA0B;QACtC,WAAW,EAAE,uBAAuB;QACpC,YAAY,EAAE,0BAA0B;IAC5C;;IAEA;QACI,SAAS,EAAE,0BAA0B;QACrC,QAAQ,EAAE,0BAA0B;QACpC,6BAA6B;IACjC;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,YAAY;QACZ,WAAW;IACf;;AAEJ","sourcesContent":[".createLiveNav {\n    position: fixed;\n    width: 100%;\n    top: 0%;\n}\n\n.createLiveSignOut {\n    /* top: 22%;\n    right: 3%; */\n    position: static;\n}\n\n.menubtn {\n    display: none;\n    margin-right: 2%;\n}\n\n.menuoptions {\n    display: none;\n}\n\n.menuoptions2 {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n\n}\n\n@media screen and (max-width: 890px) {\n\n    .responsiveContainer {\n        width: 100% !important;  /* Set to 100% for mobile and tablet */\n        flex-direction: column !important; /* Stack items vertically on smaller screens */\n    }\n\n    .topDiv {\n        width: 100%; /* Full width for mobile */\n    }\n\n    .responsiveRightDiv {\n        width: 100% !important; /* Set to 100% for mobile and tablet */\n        position: relative !important;\n    }\n\n    .createLeftDiv {\n        width: 100%; /* Full width for mobile */\n    }\n\n    .createRightDiv {\n        width: 100%; /* Full width for mobile */\n        padding: 0; /* Remove padding */\n    }\n\n    .pdfDisplayDiv {\n        width: 80%; /* Adjust PDF viewer width */\n        margin: auto; /* Center the PDF viewer */\n    }\n\n    .createFormSection {\n        margin-bottom: 2%; /* Reduce margin for better spacing */\n    }\n\n    .createLiveSaveProfileBtn {\n        width: 100%; /* Full width for buttons */\n    }\n\n    .templateDiv {\n        width: 100%; /* Full width for template selection */\n    }\n\n    .templateImg {\n        width: 80%; /* Adjust image size for mobile */\n    }\n\n    .menubtn {\n        display: block;\n        border: none;\n        outline: none;\n    }\n\n    .menuoptions2 {\n        display: none;\n    }\n\n    .menuoptions {\n        display: flex;\n        align-items: center;\n        gap: 20px;\n        position: fixed;\n        top: 65px;\n        right: 5px;\n        flex-direction: column;\n        background-color: #ecf8e5;\n        padding: 20px;\n        border-radius: 20px;\n        z-index: 10;\n    }\n\n    .liveProfileDivLeft {\n        width: 66%; /* Full width for both columns */\n        /* padding-top: 5%; */\n        /* padding-left: 5%; */\n    }\n\n    .liveProfileDivRight {\n        width: 33%; /* Full width for both columns */\n        /* padding-top: 5%;  */\n        /* right: -6.8%; */\n    }\n}\n\n.responsiveContainer {\n    display: flex;\n    flex-direction: row;\n    width: 50%; /* Set to 50% for laptop view */\n    left: 0%;\n    margin-top: 5%;\n}\n\n.topDiv {\n    flex: 1; /* Take available space */\n    padding-top: 5%; /* Add padding if needed */\n}\n\n.responsiveRightDiv {\n    position: fixed;\n    right: 0%;\n    top: 3%;\n    padding-top: 5%;\n    width: 50%; /* Default width for laptops and larger screens */\n}\n\n.createLeftDiv {\n    width: 50%;\n    display: inline-block;\n}\n\n.rightDivCreateLive {\n    /* background-color: #346571; */\n    background-image: url(\"../images/bg.png\");\n}\n\n.createLeftFormDiv {\n    padding: 4%;\n    padding-top: 7%;\n    padding-left: 8%;\n    width: 100%;\n}\n\n.createRightDiv {\n    /* background-color: aquamarine; */\n    padding: 0%;\n    padding-top: 0%;\n    z-index: -1;\n    right: 0%;\n    flex: 1;\n}\n\n.fixed-preview-button {\n    position: fixed; /* Fixes the button to the viewport */\n    bottom: 20px; /* Distance from the bottom of the viewport */\n    left: 50%; /* Center the button horizontally */\n    transform: translateX(-50%); /* Adjust for the button's width */\n    z-index: 1000; /* Ensure it appears above other content */\n    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n    border-radius: 25px;\n    color: rgb(255, 255, 255);\n    cursor: pointer;\n    display: inline-block;\n    width: 45%;\n    font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;\n    padding: 7px 20px;\n    text-align: center;\n    text-decoration: none;\n    transition: all 250ms;\n    border: 0;\n    font-size: 14px;\n    font-weight: 600;\n    user-select: none;\n    -webkit-user-select: none;\n  }\n\n  .fixed-preview-button:hover {\n    background-color: #4F80FF;\n    color: white;\n  }\n\n.downloadPdfBtn {\n    /* position: absolute; */\n    /* z-index: 20; */\n    /* background-color:rgb(23 33 58); */\n    /* right: 29.3%; */\n    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n    border: none;\n    border-radius: 25px;\n    font-weight: 550;\n    color: #ffffff;\n    height: 30px;\n    width: 38%;\n    /* top: 33%; */\n}\n\n.downloadPdfBtn:hover {\n    /* position: absolute;\n    z-index: 20; */\n    /* background-color:rgb(23 33 58); */\n    /* right: 39%; */\n    border: none;\n    /* color: rgb(34 197 94); */\n    /* top: 34%; */\n    font-weight: 550;\n}\n\n.downloadPDFIcon {\n    padding-bottom: 3%;\n}\n\n.createFormSection {\n    margin-bottom: 4%;\n}\n\n.createUplouploadPictureDivLabel {\n    top: 1%;\n    left: 33%;\n}\n\n/* .uploadPictureInput {\n   \n} */\n\n.createUploadedPicture {\n    left: 5%;\n    bottom: 8%;\n}\n\n\n.createUploadPictureInput {\n    bottom: -5%;\n    background-color: none !important;\n    width: 50% !important;\n    padding-left: 5px;\n    padding-right: 2px;\n    position: absolute;\n    /* top: 42%; */\n    bottom: -16%;\n    /* right: 8%; */\n    left: 33% !important;\n    font-size: 14px;\n\n}\n\n.createUplouploadPhotoDivIcon {\n    left: 4%;\n}\n\n.createUplouploadPhotoDivGif {\n    /* background-color: red; */\n    position: relative;\n    align-items: center;\n    text-align: center;\n    width: 70px;\n    height: 70px;\n    left: 1%;\n\n}\n\n.deleteUploadedPhotoIcon {\n    position: absolute;\n    bottom: -5%;\n    right: 5%;\n    color: grey;\n    color: goldenrod;\n\n}\n\n.deleteUploadedPhotoIcon:hover {\n    position: absolute;\n    bottom: -5%;\n    right: 5%;\n    color: rgb(112, 24, 24);\n}\n\n.createLiveSaveProfileBtn {\n    width: 100%;\n    background-color: #5ec57e;\n    color: white;\n}\n\n.createLiveSaveProfileBtn:hover {\n    width: 100%;\n    /* background-color: #c2fbd7; */\n    box-shadow: rgba(0, 0, 0, 0.3) 0 4px 8px;\n    border-radius: 25px;\n    color: #ffffff;\n}\n\n.createSaveProfileDiv {\n    position: relative;\n    align-items: center;\n    text-align: center;\n    margin-bottom: 8%;\n}\n\n.pdfDisplayDiv {\n    background-color: white;\n    width: 70%;\n    min-height: 84vh;\n    margin: auto;\n    margin-top: 2%;\n    margin-bottom: 5%;\n    padding: 2%;\n    overflow: auto;\n    max-height: 84vh;\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n    border-radius: 5px;\n}\n\n.mainCreateLiveDiv1 {\n    display: flex;\n    flex-direction: row;\n}\n\n.rightHeadDiv {\n    position: relative;\n    top: 0;\n    background-color: bisque;\n    width: 100%;\n    height: 65px;\n}\n\n.topDivTemplate1 {\n    margin-left: 3.2%;\n    margin-bottom: 2%;\n}\n\n.imageDiv {\n    display: inline-block;\n    /* background-color: aqua; */\n    margin: 0;\n    padding: 0;\n    width: 15%;\n    position: relative;\n    height: 40px;\n}\n\n.displayImage {\n    width: 45px;\n    position: absolute;\n    top: 5%;\n}\n\n.nameDiv {\n    margin: 0;\n    padding: 0;\n    display: inline-block;\n    width: 70%;\n    /* background-color: #5ec57e; */\n    margin-top: 1%;\n}\n\n.resumeName {\n    margin: 0;\n    padding: 0;\n    margin-left: 3%;\n    font-size: 14px;\n    padding-top: 3%;\n}\n\n.resumeTtile {\n    font-size: 8px;\n    margin: 0;\n    padding: 0;\n    margin-left: 3%;\n}\n\n.liveProfileDiv {\n    /* background-color: bisque; */\n    font-size: 10px;\n    width: 95%;\n    margin: auto;\n    margin-top: 4%;\n    padding: 0;\n}\n\n.liveProfileDivLeft {\n    padding: 0;\n}\n\n.liveProfileDivRight {\n    padding: 0;\n    text-align: justify;\n    text-align: left !important;\n    overflow-wrap: break-word;\n}\n\n.profileIcon {\n    position: absolute;\n    bottom: 23%;\n    left: 0;\n}\n\n.profileName {\n    padding: 0;\n    margin: 0;\n    padding-left: 4%;\n    position: relative;\n    font-weight: 520;\n    color: rgb(30, 37, 50);\n    color: rgb(22, 89, 143);\n\n    /* font-family: 'Poppins', sans-serif;\nfont-family: 'Open Sans', sans-serif; */\n}\n\n.profileText {\n    font-size: 7px;\n    text-align: justify;\n    padding-left: 5.6%;\n    color: rgb(62, 63, 78);\n    ;\n    /* font-family: 'Open Sans', sans-serif;\nfont-family: 'Poppins', sans-serif;\nfont-family: 'Roboto', sans-serif;  */\n    /* font-family: 'Open Sans', sans-serif;\nfont-family: 'Poppins', sans-serif;\nfont-family: 'Roboto', sans-serif; */\n}\n\n.employmentHistName {\n    margin-top: -3%;\n}\n\n.profileEmploymentName {\n    font-size: 7px;\n    font-weight: 500;\n    padding: 0;\n    margin: 0;\n    padding-left: 5.6%;\n    margin-top: 1.8%;\n    color: rgb(30, 37, 50);\n}\n\n.employmentTime {\n    font-size: 6px;\n    padding-left: 5.6%;\n    padding-bottom: 0;\n    margin-bottom: 0;\n}\n\n.employmetnProfileText {\n    padding-left: 5.6%;\n    margin-top: 2%;\n}\n\n.liveProfileDivRight {\n    padding-left: 20px;\n    padding-top: 0.5%;\n}\n\n.profileDetails {\n    font-size: 8px;\n    font-weight: 500;\n    margin-bottom: 1.6%;\n\n}\n\n.profileDetailsText {\n    font-size: 7px;\n    text-align: justify;\n    padding: 0;\n    margin: 0;\n    padding-top: 1%;\n}\n\n.profileDetailSubHeading {\n    margin-top: 7%;\n}\n\n.otherProfileDetails {\n    margin-top: 6%;\n    margin-bottom: 0;\n}\n\n.liveSkills {\n    font-weight: 400;\n    font-size: 8px;\n}\n\n.emailProfileDetailsText {\n    color: rgb(26, 145, 240);\n    font-weight: 500;\n}\n\n.DOBProfileDetailsText {\n    color: rgb(130, 139, 162);\n    font-weight: 600;\n    font-size: 7px;\n}\n\n.downloadPdfMainDiv {\n    /* background-color: #346571; */\n    background-image: url(\"../images/bg.png\");\n    /* background-image: url('https://media1.giphy.com/media/xTiTniuHdUjpOlNo1q/200w.webp?cid=ecf05e47oyp7v59c7cncnujecgmxgtdygfh3dyenydkegtuz&ep=v1_gifs_search&rid=200w.webp&ct=g'); */\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n    width: 100%;\n    align-items: center;\n    text-align: center;\n    position: absolute;\n    top: 0%;\n    height: 100vh;\n}\n\n.realBdfGoBackBtn {\n    width: 120px;\n    border: none;\n    /* color: #346571; */\n    /* color: green; */\n    /* color: #5ec57e; */\n    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n    font-weight: 550;\n    width: 120px;\n    border-radius: 5px;\n    position: absolute;\n    right: 3%;\n    top: 2.5%;\n    background-color: #c2fbd7;\n    border-radius: 25px;\n    /* box-shadow: rgba(44, 187, 99, .2) 0 -25px 18px -14px inset, rgba(44, 187, 99, .15) 0 1px 2px, rgba(44, 187, 99, .15) 0 2px 4px, rgba(44, 187, 99, .15) 0 4px 8px, rgba(44, 187, 99, .15) 0 8px 16px, rgba(44, 187, 99, .15) 0 16px 32px;\n    box-shadow: rgba(44, 187, 99, .35) 0 -25px 18px -14px inset, rgba(44, 187, 99, .25) 0 1px 2px, rgba(44, 187, 99, .25) 0 2px 4px, rgba(44, 187, 99, .25) 0 4px 8px, rgba(44, 187, 99, .25) 0 8px 16px, rgba(44, 187, 99, .25) 0 16px 32px; */\n    color: rgb(255, 255, 255);\n    cursor: pointer;\n    display: inline-block;\n    font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;\n    padding: 7px 20px;\n    text-align: center;\n    text-decoration: none;\n    transition: all 250ms;\n    border: 0;\n    font-size: 14px;\n    font-weight: 600;\n    user-select: none;\n    -webkit-user-select: none;\n    z-index: 15;\n}\n\n.realBdfGoBackBtn:hover {\n    background-color: #5ec57e;\n    color: #ecf8e5;\n    box-shadow: rgba(0, 0, 0, 0.2) 0 4px 8px; /* Example shadow with black color */}\n\n.languageLevel {\n    font-size: 7px !important;\n}\n\n.dashboardBtn {\n    /* position: absolute;\n    z-index: 20; */\n    /* background-color: rgb(23 33 58); */\n    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n    /* right: 39%; */\n    border: none;\n    border-radius: 25px;\n    color: rgb(255, 255, 255);\n    /* top: 34%; */\n    font-weight: 550;\n    height: 30px;\n    width: 28%;\n}\n\n.dashboardBtn:hover {\n    /* position: absolute;\n    z-index: 20; */\n    /* background-color:rgb(23 33 58); */\n    /* right: 39%; */\n    border: none;\n    /* color: rgb(34 197 94); */\n    /* top: 34%; */\n    font-weight: 550;\n}\n\n.templateDiv {\n    /* background-color: #c2fbd7; */\n    padding-top: 2%;\n    padding-bottom: 2%;\n    width: 95%;\n    margin: auto;\n    margin-top: -4%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.templateImgDiv {\n    width: 50%;\n    display: inline-block;\n}\n\n.templateImg {\n    width: 100px;\n    cursor: pointer;\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;\n    box-shadow: rgba(12, 192, 72, 0.1) 0px 4px 12px;\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;\n}\n\n.templateDiv {\n    padding-top: 2%;\n    padding-bottom: 2%;\n}\n\n.tempalteImage {\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n}\n\n.tempalteImage {\n    width: 90%;\n}\n\n.templateDiv {\n    margin-bottom: 5%;\n    margin-top: 2%;\n}\n\n.carousel-item {\n    height: 260px;\n    background-color: white;\n}\n\n.live-carousel-control-next {\n    right: -47px;\n}\n\n.live-carousel-control-next {\n    background-color: #5ec57e;\n    right: -20px;\n    height: 34px;\n    top: 72px;\n    width: 26px;\n}\n\n.live-carousel-control-prev {\n    left: -35px;\n    height: 34px;\n    top: 72px;\n    width: 26px;\n    background-color: #5ec57e;\n}\n\n.landing-carousel-control-next {\n    background-color: #5ec57e;\n    height: 40px;\n    width: 30px;\n    margin-right: 5%;\n    margin-top: 22%;\n}\n\n.landing-carousel-control-prev {\n    background-color: #5ec57e;\n    height: 40px;\n    width: 30px;\n    margin-left: 5%;\n    margin-top: 22%;\n}\n\n.tailorDivImg {\n    width: 100%;\n}\n\n.createLiveHrLine {\n    margin-bottom: 5%;\n}\n\n.liveInfoOuterDiv {\n    background-color: red;\n    background-color: transparent;\n    position: relative;\n    margin-top: 3%;\n\n}\n\n.aiItAnimationDiv {\n    position: absolute;\n    right: 3%;\n    top: -5% !important;\n    /* background-color: #346571; */\n    background-color: transparent;\n    /* background-color: blue; */\n    height: 60px;\n    cursor: pointer;\n    z-index: 1;\n}\n\n.aiItAnimationDivDesc {\n    position: absolute;\n    right: 3%;\n    top: -59% !important;\n    /* background-color: #346571; */\n    background-color: transparent;\n    height: 28px;\n    cursor: pointer;\n}\n\n.bulbGif {\n    height: 50px;\n    width: 50px;\n    z-index: 5;\n    pointer-events: none;\n}\n\n.cityLabelForm {\n    margin-bottom: 4% !important;\n}\n\n.moveBtnCreateUp {\n    background-color: transparent;\n    /* background-color: #346571; */\n    border: none;\n    text-align: right;\n    position: absolute;\n    top: -2%;\n    width: 10%;\n    right: -2%;\n\n}\n\n.moveBtnCreateDown {\n    background-color: transparent;\n    /* background-color: #346571; */\n    border: none;\n    text-align: right;\n    position: absolute;\n    top: 1.7%;\n    width: 10%;\n    right: -2%;\n}\n\n.moveBtnCreateWebsiteUp {\n    background-color: transparent;\n    /* background-color: #346571; */\n    border: none;\n    text-align: right;\n    position: absolute;\n    top: -43%;\n    width: 10%;\n    right: 0%;\n}\n\n.moveBtnCreateWebsiteDown {\n    background-color: transparent;\n    /* background-color: #346571; */\n    border: none;\n    text-align: right;\n    position: absolute;\n    top: -16.5%;\n    width: 10%;\n    right: 0%;\n}\n\n.moveBtnCreateNotLiveDown {\n    background-color: transparent;\n    /* background-color: #346571; */\n    border: none;\n    text-align: right;\n    position: absolute;\n    top: 8.5%;\n    width: 10%;\n    right: -2%;\n}\n\n.infoTextDiv {\n    position: absolute;\n    /* visibility: hidden; */\n    width: 200px;\n    background-color: #555;\n    color: #fff;\n    text-align: center;\n    border-radius: 6px;\n    padding: 10px;\n    z-index: 1;\n    top: -50px;\n    /* Adjust this value to position the tooltip */\n    left: 50%;\n    margin-left: -100px;\n    opacity: 0;\n    transition: opacity 0.3s;\n}\n\n.SaveBtn {\n    /* position: absolute;\n    z-index: 20; */\n    /* background-color:rgb(23 33 58); */\n    /* right: 46.3%; */\n    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n    border: none;\n    border-radius: 25px;\n    color: rgb(255, 255, 255);\n    /* top: 34%; */\n    font-weight: 550;\n    height: 30px;\n    width: 20%;\n}\n\n.SaveBtn:hover {\n    /* position: absolute;\n    z-index: 20; */\n    /* background-color:rgb(23 33 58); */\n    /* right: 39%; */\n    border: none;\n    /* color: rgb(34 197 94); */\n    /* top: 34%; */\n    font-weight: 550;\n}\n\n/* .checkTokenClass{\n    box-shadow:  4px 4px 6px 0 rgba(255,255,255,.5),\n              -4px -4px 6px 0 rgba(116, 125, 136, .5), \n    inset -4px -4px 6px 0 rgba(255,255,255,.2),\n    inset 4px 4px 6px 0 rgba(0, 0, 0, .4);\n  } */\n\n/* 2 */\n/* .btn-2 {\n    background: rgb(96,9,240);\n    background: linear-gradient(0deg, rgba(96,9,240,1) 0%, rgba(129,5,240,1) 100%);\n    border: none;\n    \n  } */\n.btn-2:before {\n    height: 0%;\n    width: 2px;\n}\n\n.btn-2 {\n    border: none;\n    box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, .5),\n        -4px -4px 6px 0 rgba(116, 125, 136, .5),\n        inset -2px -2px 6px 0 rgba(255, 255, 255, .2),\n        inset 2px 2px 6px 0 rgba(0, 0, 0, .2);\n}\n\n\n.custom-btn {\n    width: 180px;\n    height: 40px;\n    color: #fff;\n    border-radius: 20px;\n    padding: 10px 10px;\n    font-family: 'Lato', sans-serif;\n    font-weight: 500;\n    background: transparent;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    /* position: absolute; */\n    display: inline-block;\n    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),\n        5px 5px 15px 0px rgba(0, 0, 0, .1),\n        4px 4px 5px 0px rgba(0, 0, 0, .1);\n    outline: none;\n}\n\n.btn-2 {\n    border: none;\n    box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, .5),\n        -4px -4px 6px 0 rgba(116, 125, 136, .5),\n        inset -2px -2px 6px 0 rgba(255, 255, 255, .2),\n        inset 2px 2px 6px 0 rgba(0, 0, 0, .2);\n}\n\n@media (max-width: 767px) {\n\n    .uplouploadPictureBigDiv {\n        width: 100%; /* Full width on mobile */\n        padding: 10px; /* Add some padding */\n        margin-bottom: 30px !important;\n        margin-top: 30px !important;\n    }\n\n    .uplouploadPhotoDivIcon {\n        right: 10%; /* Adjust icon position */\n        bottom: 5%; /* Adjust icon position */\n        height: 50px !important;\n        width: 50px !important;\n    }\n\n    .uploadedPicture {\n        right: 5%; /* Adjust image position */\n        bottom: 5%; /* Adjust image position */\n        width: 50px; /* Smaller image size */\n        height: 50px; /* Maintain aspect ratio */\n    }\n\n    .uplouploadPictureDivLabel {\n        top: 30px; /* Adjust label position */\n        left: 0%; /* Adjust label position */\n        position: relative !important;\n    }\n\n    .createUploadPictureInput{\n        top: 0 !important;\n        right: 0 !important;\n    }\n}\n\n@media only screen and (max-width: 768px) {\n    .SaveBtn {\n        height: 30px;\n        width: 100%;\n    }\n    .dashboardBtn {\n        height: 30px;\n        width: 100%;\n    }\n    .downloadPdfBtn {\n        height: 30px;\n        width: 100%;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
